import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import AppContainer from '../../components/AppContainer/AppContainer'
import './AnalyticalReport.scss'
import QueryReport from './QueryReport/QueryReport';

const AnalyticalReport=(props)=> {
    const { history } = props;
    const navigate = useNavigate()
    const [activeTab, setActiveTab] = useState("");

    useEffect(() => {
        const activeTabData = localStorage.getItem('activeReportPage');
        setActiveTab(activeTabData ? activeTabData : 'queryReport');
    }, [])


    return (
        <AppContainer history={history}>
            <div className="event-table">
                <QueryReport activeTab={activeTab} />
            </div>
        </AppContainer >
    )
}

export default AnalyticalReport
